module.exports = __webpack_public_path__ + "static/media/Archive.65f461e1.png";